import ContentConfig from '../../config/ContentConfig';
import PlaybackSectionConfig from '../../config/PlaybackSectionConfig';
import { ElevenAgentData } from '../../ecdn11/interfaces';
import logger from '../../log';
import { PrimingData } from '../../priming/interfaces';
import { checkVersionGE } from '../../util/checkVersion';
import { DeliveryMode, PlayType } from '../constants';
import getPlaybackPriority from './getPlaybackPriority';

const log = logger.getLogger(__filename);

export const MIN_AGENT_FOR_PEER_DISABLED = '11.6.0';
const { ECDN11, WEBRTC } = DeliveryMode;

const modes = (
  type: PlaybackSectionConfig,
  allowed: Set<DeliveryMode>
): DeliveryMode[] => {
  const priority = type?.priority || '';
  return getPlaybackPriority(priority).filter(m => allowed.has(m));
};

export const matchingAgent = (mode: DeliveryMode, ecdn11?: ElevenAgentData) => {
  if (mode !== ECDN11) {
    return true;
  }
  const min = MIN_AGENT_FOR_PEER_DISABLED;
  const version = ecdn11?.version;
  return version && checkVersionGE({ version, min });
};

export default function getModeAttemptOrder(
  config: ContentConfig,
  allowedModes = [ECDN11, WEBRTC],
  agentData?: PrimingData
): {
  [PlayType.LIVE]: DeliveryMode[];
  [PlayType.VOD]: DeliveryMode[];
} {
  log.debug('getModeAttemptOrder:', { config, allowedModes });
  const { ecdn11 } = agentData ?? {};
  const { playback } = config || {};
  const peeringDisabled = config?.peering?.peeringDisabled ?? false;
  const { vod, live } = playback || {};

  const allowedSet = allowedModes.reduce(
    (acc: Set<DeliveryMode>, next: DeliveryMode) => {
      if (
        peeringDisabled &&
        (next === WEBRTC || !matchingAgent(next, ecdn11))
      ) {
        return acc;
      }
      acc.add(next);
      return acc;
    },
    new Set()
  );

  const liveModes = modes(live, allowedSet);
  const vodModes = modes(vod, allowedSet);

  // if it is allowed and enabled but the browser does not support it, report it as unsupported.
  return {
    [PlayType.LIVE]: liveModes,
    [PlayType.VOD]: vodModes
  };
}
